import styled from "styled-components";

export const HomePageBannerContainer = styled.picture`
  height: 218px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0px;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    height: 254px;
  }
`;

interface ImageBannerProps {
  background: string;
}

export const HeroHomePageBannerContainer = styled.div<ImageBannerProps>`
  background-image: linear-gradient(180deg, rgba(122, 0, 0, 0.6) -12.32%, rgba(119, 0, 0, 0) 38.24%),
    url(${({ background }) => background + "-desktop.webp"});
  background-repeat: no-repeat;
  border-radius: 20px;

  margin-top: 24px;
  width: 327px;
  height: 400px;
  background-position-x: 50%;
  background-position-y: 55%;
  background-size: 250%;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    margin-top: 24px;
    width: 696px;
    height: 500px;
    background-position-x: 45%;
    background-position-y: 55%;
    background-size: 140%;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    margin-top: 24px;
    width: 1156px;
    height: 450px;
    background-position-x: 5%;
    background-position-y: 58%;
    background-size: 150%;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("xxl")} {
    width: 1572px;
    height: 580px;
    background-position-x: 10%;
    background-position-y: 58%;
    background-size: 140%;
  }
`;

export const HeroV2HomePageBannerContainer = styled.div<ImageBannerProps>`
  background-image: url(${({ background }) => background + "-mobile.webp"});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  border-radius: 20px;

  margin-top: 24px;
  width: 327px;
  height: 400px;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    margin-top: 24px;
    width: 696px;
    height: 500px;
    background-image: url(${({ background }) => background + "-tablet.webp"});
    background-position: center;
    background-size: 100%;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    margin-top: 24px;
    width: 1156px;
    height: 450px;
    background-image: url(${({ background }) => background + "-desktop.webp"});
    background-position: center;
    background-size: 100%;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 4px;
  padding: 40px 25px;
  text-align: center;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    text-align: center;
    padding: 60px 190px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    text-align: left;
    width: 55%;
    align-items: flex-start;
    padding: 89px 118px 0px 118px;
    margin-top: 0%;

    gap: 12px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("xxl")} {
    text-align: left;
    width: 40%;
    padding: 154px 114px 0px 114px;

    gap: 12px;
  }
`;

export const InfoContainerV2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 4px;
  padding: 40px 25px;
  text-align: center;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    text-align: center;
    padding: 60px 190px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    text-align: left;
    width: 55%;
    align-items: flex-start;
    padding: 149px 118px 149px 118px;
    gap: 12px;
  }
`;

export const BannerSubTitle = styled.span`
  font-family: ThemeFontRegular;
  color: ${({ theme }) => theme.customTheme.palette.bannerSubTitle.textColor};
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    font-size: 18.24px;
    line-height: 22.24px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: 24px;
    line-height: 28px;
  }
`;

export const BannerTitle = styled.span`
  font-family: ThemeFontRegular;
  color: ${({ theme }) => theme.customTheme.palette.bannerTitle.textColor};
  font-weight: 700;
  font-size: 32px;
  line-height: 40px;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    font-size: 36.48px;
    line-height: 44.48px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: 48px;
    line-height: 56px;
  }
`;

export const LogoContainer = styled.div`
  margin-top: 32%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 16px;
  padding: 40px 25px;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    padding: 40px 220px;
    margin-top: 20%;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    width: 40%;
    justify-content: flex-start;
    padding: 60px 118px 89px 118px;
    margin-top: 0%;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("xxl")} {
    width: 32%;
    padding: 60px 114px 154px 114px;
  }
`;

export const ImageLogo = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    width: 60px;
    height: 60px;
  }
`;
